import * as React from "react";

import * as journal from "@client/features/journal";

import * as router from "@client/router";

import {Form} from "@client/forms";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

export const UpdateMeasurements = router.UpdateMeasurements.withHooks((props) => {
    const measurement = props.resolved.journal.day.measurements[0];

    return {
        form: forms.useAutoPform(server.journal.day.MeasurementForm, measurement),
    };
})
    .withIndex((props) => {
        React.useEffect(() => {
            setTimeout(() => {
                (document.querySelector(".label input") as HTMLInputElement).focus();
            }, 500);
        }, []);

        const measurements = props.profile.user.get_measurements;

        return (
            <>
                {props.profile.user.email === "maryzaida@hotmail.com" && (
                    <div
                        style={{
                            fontSize: "2rem",
                            textAlign: "center",
                            margin: "1rem 0",
                        }}
                    >
                        Ma, medir la cintura.
                        <br />
                        Chop chop.
                        <br />
                        ❤️
                    </div>
                )}
                <Form>
                    {measurements.map((name) => (
                        <forms.PField key={name} field={props.form.fields[name]} />
                    ))}
                </Form>
            </>
        );
    })
    .withActions((props) => [
        {
            icon: "save",
            title: "Save",
            onClick: () =>
                props.dispatch(
                    journal.updateMeasurements(props.resolved.journal, props.form),
                ),
        },
    ])
    .withOptions(() => ({
        isDelegatable: true,
        title: "Measurements",
        back: "Journal",
        scene: {kind: "SIMPLE"},
    }));
